<template>
	<div class="fill-height pt-2">
		<LeavesDialog 
			ref="leaveDialogRef"
			:dialog.sync="dialog" 
			:leaveId="leaveId"
			@submit="submitLeave"
		/>
		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card>
				<v-card-title>
					Delete leave
				</v-card-title>
				<v-card-text>
					Are you sure you want to delete this leave ?
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="alert-color white--text"
						class="rounded-lg text-none"
						:loading="submitLoading"
						@click="deleteLeave()"
					>
						Yes
					</v-btn>
					<v-btn
						@click="deleteDialog = false"
						class="rounded-lg text-none"
						:disabled="submitLoading"
						text
					>
						No
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-card
			:style="!$vuetify.theme.dark ? '' : null" 
			class=" rounded-lg"
			:class="{
				'box': !$vuetify.theme.dark
			}"
		>
			<v-card-text class="d-flex justify-space-between align-center fill-height">
				<div v-for="(leave, index) in leavesRemaining" :key="index" class="d-flex justify-center ml-3">
					<div class="d-flex justify-center align-center">
						<v-img
							v-if="!$vuetify.theme.dark"
							src="../../assets/Vectors/clock-nine (1).svg"
							width="20"
						/>
						<v-img
							v-else
							src="../../assets/Vectors/clock-nine-white.svg"
							width="20"
						/>
					</div>
					<div class="d-flex flex-column mx-3">
						<span class="font-weight-bold text-body-1 zain-bold"> {{ leave ? leave.remainingLeaves : '-' }} </span>
						<span class="font-weight-medium text-subtitle-3 zain-bold"> {{ leave ? getLeaveTypeById(leave.leaveTypeId).name : '-' }} </span>
					</div>
				</div>
				<v-spacer></v-spacer>
				<v-btn
					depressed
					color="green accent-4 d-flex justify-center mr-3"
					class="text-none rounded-lg white--text"
					@click="dialog = true"
					:disabled="loading"
				>
					<v-icon left class="white--text">mdi-plus</v-icon>
					Add Leave
					<!-- Dialog's content -->
				</v-btn>
			</v-card-text>
		</v-card>
		
		<bee-handy-table
			dense
			:headers="headers"
			:items="leavesByUser"
			:items-per-page="50"
			class="mt-8"
			:height="$vuetify.breakpoint.height - 180"
			fixed-header="true"
			hide-default-footer
			:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e9': null"
			:item-class="applyRowClass"
			mobile-breakpoint="960"
			:loading="loading"
			table-class="rounded-lg"
		>
			<template v-slot:item.type="{ item }"> 
				<img
					v-if="item.isDaily"
					src="../../assets/Leaves/daily-calendar.svg"
					alt="Daily Type"
					width="20px"
					class="ml-3"
				>
				<img
					v-else
					src="../../assets/Leaves/calendar-clock.svg"
					alt="Hourly Type"
					width="20px"
					class="ml-3"
				>
			</template>

			<template v-slot:item.status="{ item }">

				<v-chip small :class="getStatusColor(item.status)">
					{{ item.status === 0 ? 'Pending' : item.status === 1 ? 'Acceptance' : 'Rejected' }}
				</v-chip> 
			</template>

			<template v-slot:item.actions="{ item }"> 
				<div class="d-flex">
					<v-btn
						v-if="item.managerAcceptance === null && item.supervisorAcceptance === null"
						@click="dialog = true; leaveId = item.id"
						icon
					>
						<v-icon color="edit-color">mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						v-if="item.managerAcceptance === null && item.supervisorAcceptance === null"
						@click="deleteDialog = true; deleteItemId = item.id"
						icon
					>
						<v-icon color="alert-color">mdi-delete</v-icon>
					</v-btn>
				</div>
			</template> 

			<!-- <template v-if="0" v-slot:body="props">
				<tbody> 
					<tr v-for="(item, index) in props.items" :key="item.id" :class="applyRowClass(index)"> 
						<td v-for="header in headers" :key="header.value"> 

							<template v-if="header.value === 'type'"> 
								<img
									v-if="item.isDaily"
									src="../../assets/Leaves/daily-calendar.svg"
									alt="Daily Type"
									width="20px"
									class="ml-3"
								>
								<img
									v-else
									src="../../assets/Leaves/calendar-clock.svg"
									alt="Hourly Type"
									width="20px"
									class="ml-3"
								>
							</template>

							<template v-else-if="header.value === 'status'"> 
								<v-chip small :class="getStatusColor(item.status)">
									{{ item[header.value] }}
								</v-chip>
							</template> 

							<template v-else-if="header.value === 'delete'"> 
								<v-icon class="ml-2 red--text">mdi-delete</v-icon>
							</template> 

							<template v-else> 
								{{ item[header.value] }} 
							</template> 

						</td> 
					</tr> 
				</tbody> 
			</template> -->
		</bee-handy-table>
	</div>
</template>
<script>
import LeavesDialog from '@/components/Leaves/LeavesDialog.vue'
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
	components: {
		LeavesDialog
	},
	watch: {
		dialog (val) {
			if (!val) {
				this.leaveId = null
			}
		}
	},
	data () {
		return {
			deleteDialog: false,
			headers: [
				{
					text: 'Leave Type',
					align: 'start',
					value: 'type',
					name: 'type',
					width: '100px',
					sortable: false
				},
				{ 
					text: 'From', 
					value: 'fromDate', 
					name: 'fromDate',
					setValueExpr: val => moment(val).format('YYYY-MM-DD'),
					width: '100px',
					sortable: false 

				},
				{ 
					text: 'To', 
					name: 'toDate', 
					value: 'toDate',
					setValueExpr: val => moment(val).format('YYYY-MM-DD'),
					width: '100px',
					sortable: false 

				},
				{ 
					text: 'Days', 
					value: 'durationInDays', 
					name: 'durationInDays',
					width: '75px',
					sortable: false 

				},
				{ 
					text: 'Hours', 
					name: 'durationInMinute',
					value: 'durationInMinute', 
					setValueExpr: val => val > 0 ? (val / 60).toFixed(2) : '-',
					width: '100px',
					sortable: false 

				},
				{ 
					text: 'Reason', 
					value: 'reason', 
					name: 'reason',
					width: '350px',
					sortable: false 

				},
				{ 
					text: 'Status', 
					name: 'status',
					value: 'status', 
					width: '60px',
					sortable: false 

				},
				{
					text: '',
					value: 'actions',
					name: 'actions',
					width: '40px',
					sortable: false
				}
			],
			// cards: [
			// 	{	
			// 		id: 1,
			// 		type: 'Daily',
			// 		from: '1 Apr 2024',
			// 		to: '5 Oct 2024',
			// 		days: '5 Days',
			// 		hours: '24 Hours',
			// 		reason: 'something, am just trying to do more and more practice with tabels so i can become a good front end developer',
			// 		status: 'Approved',
			// 		del: 's'
			// 	},
			// 	{	
			// 		id: 2,
			// 		type: 'Hourly',
			// 		from: '5 Oct 2024',
			// 		to: '1 Nov 2024',
			// 		days: '6 Days',
			// 		hours: '-',
			// 		reason: 'here i am also typing so i can become more and more friendly with tables',
			// 		status: 'Pinned',
			// 		del: 's'
			// 	},
			// 	{	
			// 		id: 3,
			// 		type: 'Hourly',
			// 		from: '4 Oct 2023',
			// 		to: '1 Nov 2024',
			// 		days: '6 Days',
			// 		hours: '5',
			// 		reason: 'here i am also typing so i can become more and more friendly with tables',
			// 		status: 'Approved',
			// 		del: 's'
			// 	},
			// 	{	
			// 		id: 4,
			// 		type: 'Daily',
			// 		from: '4 Oct 2023',
			// 		to: '1 Nov 2024',
			// 		days: '6 Days',
			// 		hours: '-',
			// 		reason: 'here i am also typing so i can become more and more friendly with tables',
			// 		status: 'Pinned',
			// 		del: 's'
			// 	},
			// 	{	
			// 		id: 5,
			// 		type: 'Hourly',
			// 		from: '4 Oct 2023',
			// 		to: '1 Nov 2024',
			// 		days: '6 Days',
			// 		hours: '-',
			// 		reason: 'here i am also typing so i can become more and more friendly with tables',
			// 		status: 'Approved',
			// 		del: 's'
			// 	}
			// ],
			dialog: false,
			leavesByUser: [],
			leavesRemaining: [],
			submitLoading: false,
			loading: false,
			deleteItemId: null,
			leaveId: null
		}
	},

	methods: {
		moment,
		// API Work
		// ...mapActions(['fetchUser', 'fetchRemaining', 'fetchLeavesByUserId']),
		//
		applyRowClass (index) { 
			if (index % 2 === 0) {
				return 'primary-light'
			} else {
				return ''
			}
		},
		getStatusColor (status) { 
			if (status === 1) {
				return 'green lighten-5 green--text text--accent-4';
			} else {
				return 'yellow lighten-5 amber--text text--accent-4';
			}
		},
		submitLeave (submitData) {
			const actionName = this.leaveId ? 'update' : 'addLeave'
			this.$store.dispatch(`leaves/${actionName}`, { ...submitData, id: this.leaveId }).then(() => {
				this.dialog = false
				this.getSelfLeaves()
				this.fetchRemaining()
				this.$refs.leaveDialogRef.resetLoading()
			}).catch(error => {
				console.error('Error Adding Leave:', error)
				this.$refs.leaveDialogRef.resetLoading()
			})
		},

		deleteLeave () {
			this.submitLoading = true
			this.$store.dispatch('leaves/delete', { id: this.deleteItemId }).then(() => {
				this.getSelfLeaves()
				this.deleteDialog = false
			}).finally(() => {
				this.submitLoading = false
				this.deleteItemId = null
			})	
		},

		getSelfLeaves () {
			this.$store.dispatch('leaves/fetchLeavesByUserId', { userId: this.self.id, year: moment().year() }).then((data) => {
				this.leavesByUser = data
			}).finally(() => {
				this.loading = false
			})
		},

		fetchRemaining () {
			this.$store.dispatch('leaves/fetchRemaining', { userId: this.self.id }).then((data) => {
				this.leavesRemaining = data
			})
		}
	},
	computed: {
		...mapState({
			remainings: state => state.leaves.remaining,
			self: state => state.auth.self,
			userId: state => state.auth.self.id,
			leavesTypeForEmployee: state => state.leaves.leavesTypeForEmployee
		}),
		...mapGetters({
			getLeavesById: 'leaves/getLeavesById',
			getLeaveTypeById: 'leaves/getLeaveTypeById'
		})
	},
	created () {
		const userId = this.self.employeeId;
		this.fetchRemaining()
		this.loading = true
		this.getSelfLeaves()
	}
}
</script>
<style scoped>
</style>
